import script from "./LoginView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginView.vue?vue&type=style&index=0&id=c45c3548&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c45c3548"]])

export default __exports__